import React, { Component } from 'react';
import { Select, Radio, Checkbox, Button, Input } from 'components/index';
import { getFormInfo } from 'api/Ajax/index';

export default class FormModule extends Component{
    state = {
        chatUrl : '',// 跳转URL
    }

    componentDidMount(){
        const _this = this;
        // 置入咨询链接
        if(this.props.content.style){
            getFormInfo( '/getTalkCode', { style: this.props.content.style }, 'POST' ).then(( data )=>{
                if(data.code === 200){
                    _this.setState({ chatUrl: data.info })
                }
            })
            .catch( ( info )=>{
            })
        } 
    }

    render () {
        const { id, model, content, afterFormChange, submit, componentKey } = this.props
        const _this = this;
        return(
            <div 
                className = { [model,"form_box"].join(" ") } 
                style={{ 
                    background: content.bgcolor,
                    borderColor: content.bgcolor,
                }}
            >
                {
                    model === 'picture' ?
                    <div>
                        {
                            (content.imgUrl[0].pic_url === '' || content.imgUrl[0].pic_url === null) ?
                            <div className='picture_placeholder'>
                                <span className='icon font_family icon-zhanweitu'></span>
                            </div>:
                            <img src={ content.imgUrl[0].pic_url }/>
                        }
                    </div> :
                    model === 'pictures' ?
                    <div className="picture_box">
                        {   
                            content.imgUrl.map((item,key)=>{
                                if(item.pic_url === '' || item.pic_url === null){
                                    return (
                                        <div key={ key } className='picture_placeholder'>
                                            <span className='icon font_family icon-zhanweitu'></span>
                                        </div>
                                    )
                                }else{
                                    return (
                                        <div key={ key }>
                                            <img src={ item.pic_url }/>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div> :

                    model === 'title' || model === 'text'?
                    <div className={ model+'_box'} 
                        style={{ textAlign : content.align == "1" ? "left" : content.align == "2" ? "center" : "right" }}
                        dangerouslySetInnerHTML={{__html: content.text}}
                    />:
                    model === 'up_down_picture_text' ?
                    <div 
                        className="pic_text_u_d"
                        style={{ 
                            textAlign:content.align == "1" ? "left" : content.align == "2" ? "center" : "right"
                        }}
                    >
                        {
                            content.imgUrl.map((item,key)=>{
                                let text  = content.text[key];
                                if(item.pic_url === '' || item.pic_url === null){
                                    return (
                                        <div 
                                            key={ key }
                                            className={content.layout == "1" ? "is_reverse" : ""}
                                        >
                                            <div 
                                                className='text_box'
                                                style={{ 
                                                    textAlign:content.align == "1" ? "left" : content.align == "2" ? "center" : "right"
                                                }}
                                                dangerouslySetInnerHTML={{__html: text}}
                                            ></div> 
                                            <div className='picture_placeholder'>
                                                <span className='icon font_family icon-zhanweitu'></span>
                                            </div>
                                        </div>
                                    )
                                }else{
                                    return (
                                        <div 
                                            key={ key }
                                            className={content.layout == "1" ? "is_reverse" : ""}
                                        >
                                            <div 
                                                className='text_box'
                                                style={{ 
                                                    textAlign:content.align == "1" ? "left" : content.align == "2" ? "center" : "right"
                                                }}
                                                dangerouslySetInnerHTML={{__html: text}}
                                            ></div> 
                                            <div className='pic_box'>
                                                <img src={ item.pic_url }/>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div> :
                    model === 'left_right_picture_text' ?
                    <div className='pic_text_l_r' 
                        style={{ 
                            textAlign:content.align == "1" ? "left" : content.align == "2" ? "center" : "right"
                        }}
                    >
                        {
                            (content.imgUrl[0].pic_url === '' || content.imgUrl[0].pic_url === null) ?
                            <div 
                                className={content.layout == "1" ? "" : "is_reverse"}
                            >
                                <div className='picture_placeholder pic_box' style={{ width:content.ratio == "1" ? "100%" : content.ratio == "2" ? "50%" : "200%"}}>
                                    <span className='icon font_family icon-zhanweitu'></span>
                                </div>
                                <div className='text_box' dangerouslySetInnerHTML={{__html: content.text}}></div> 
                            </div>:
                            
                            <div
                                className={content.layout == "1" ? "" : "is_reverse"}
                            >
                                <div className='pic_box' style={{ width:content.ratio == "1" ? "100%" : content.ratio == "2" ? "50%" : "200%"}}>
                                    <img src={ content.imgUrl[0].pic_url }/>
                                </div>
                                <div className='text_box' dangerouslySetInnerHTML={{__html: content.text}}></div> 
                            </div>
                        }
                    </div> :
                    model === 'cross_line' ?
                    <p style={{backgroundColor:content.color}}></p> :
                    model === 'name' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                blurType: content.must === false ? "" : "blank",
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag) },
                            }}
                        />
                    </div> :
                    model === 'phone' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                blurType: content.verify === true ? "mobile" : content.must === false ? "" : "blank",
                                keyUpType: 'mobile', // 是否开启自带的实时输入校验, 错误输入将被剔除, 默认关闭( 参数说明【'': 关闭, num: 数字, mobile: 手机号, wechat: 微信号, email: 邮箱, qq: QQ号,phone: 座机号】 )
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag ) },// 输入框失焦回调
                            }}
                        />
                    </div> :
                    model === 'wechat' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                blurType: content.verify === true ? "wechat": content.must === false ? "" : "blank",
                                keyUpType: 'wechat', // 是否开启自带的实时输入校验, 错误输入将被剔除, 默认关闭( 参数说明【'': 关闭, num: 数字, mobile: 手机号, wechat: 微信号, email: 邮箱, qq: QQ号,phone: 座机号】 )
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag) },// 输入框失焦回调
                            }}
                        />
                    </div> :
                    model === 'qq' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                blurType: content.verify === true ? "qq": content.must === false ? "" : "blank",
                                keyUpType: 'qq', // 是否开启自带的实时输入校验, 错误输入将被剔除, 默认关闭( 参数说明【'': 关闭, num: 数字, mobile: 手机号, wechat: 微信号, email: 邮箱, qq: QQ号,phone: 座机号】 )
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag) },// 输入框失焦回调
                            }}
                        />
                    </div> :
                    model === 'email' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                blurType: content.verify === true ? "email": content.must === false ? "" : "blank",
                                keyUpType: 'email', // 是否开启自带的实时输入校验, 错误输入将被剔除, 默认关闭( 参数说明【'': 关闭, num: 数字, mobile: 手机号, wechat: 微信号, email: 邮箱, qq: QQ号,phone: 座机号】 )
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag ) },
                            }}
                        />
                    </div> :
                    model === 'input' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'input',
                                value: content.value || '',// 当前输入框的值, 默认为空
                                height: '28',
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',// 报错方式, 默认为0 ( 参数说明: 【0: 关闭报错开关, 1:弹层报错,2:下方小字报错】)
                                errorText: '',
                                blurType: content.must === false ? "" : "blank",
                                maxLength: 200, // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag ) },// 输入框失焦回调
                            }}
                        />
                    </div> :
                    model === 'textarea' ?
                    <div>
                        <div className='form_title'>{ content.title }{content.must === false ? "" : "（必填）"}</div> 
                        <Input
                            key = { componentKey }
                            config= {{
                                inputType: 'textarea',
                                value: content.value || '',
                                height: '60',// 输入框高度, 默认 28px
                                width: '100%',// 输入框宽度, 默认100%
                                errorShow: content.errorShow || false,// 是否展示报错信息, 默认关闭
                                errorType: '3',
                                blurType: content.must === false ? "" : "blank",
                                maxLength: '200', // 允许输入字符数, 默认不限制
                                blur( value, flag ){ afterFormChange( id, value, flag ) },
                            }}
                        />
                    </div> :
                    model === 'select' ?
                    
                    <div>
                        <div className='form_title'>{ content.title }</div> 
                        
                        <Select
                            key = { componentKey }
                            config={{
                                list: content.list,
                                defaultId: '',
                                width: '100%',
                                check(data){ afterFormChange( id, data.value) },// 点击选择后的回调
                            }}
                        />
                    </div> :
                    model === 'radio' ?
                    <div>
                        <div className='form_title'>{ content.title }</div> 
                        <Radio
                            key = { componentKey }
                            config={{
                                defaultCheck: '1',
                                data: content.list,
                                check(data){ afterFormChange( id, data.value) },// 点击选择后的回调
                            }}
                        />
                    </div> :
                    model === 'checkbox' ?
                    <div>
                        <div className='form_title'>{ content.title }</div> 
                        <Checkbox
                            key = { componentKey }
                            config={{
                                data : content.list,
                                margin: '0 10px 0 0',
                                check(data){ 
                                    let checkedArr = [];
                                    for( let i in data ){
                                        checkedArr.push( data[i].value );
                                    }
                                    afterFormChange( id, checkedArr.join(",")) 
                                }
                            }}
                        />
                    </div> :
                    model === 'submit' ?
                        
                    <Button
                        config={{
                            type : 'custom',
                            text : content.text,
                            customCss: { backgroundColor: content.background, borderColor: content.border, color: content.color },
                            fontSize : 14,
                            height : 40,
                            check(){ submit( id ) }
                        }}
                    /> :

                    model === 'online_chat' ?
                    <Button
                        config= {{
                            text: content.text,
                            type: 'custom',
                            customCss: { backgroundColor: content.background, borderColor: content.border, color: content.color },
                            height: 28,
                            fontSize : 14,
                            height : 40,
                            check(){  
                                window.open( window.location.protocol+'//'+_this.state.chatUrl ) 
                            }
                        }}
                    />
                    : 
                    ''
                }
            </div>
        )
    }
}